import { Action, State, StateContext, createSelector } from '@ngxs/store';
import { AuthAction } from './auth.action';
import { AuthType } from 'src/app/shared/types/auth.types';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StorageService } from 'src/app/shared/services/storage/storage.service';
import { StorageKeys } from 'src/app/shared/enums/storage.enum';

@State<AuthType>({
  name: 'auth',
  defaults: {
    isLoading: false,
  },
})
@Injectable()
export class AuthState {
  static getTokens = () =>
    createSelector([AuthState], (state: AuthType) => state);

  static getIsLoading = () =>
    createSelector([AuthState], (state: AuthType) => state.isLoading);

  constructor(
    private service: AuthService,
    private storageService: StorageService
  ) {}

  @Action(AuthAction.Login)
  login(_: StateContext<AuthType>, action: AuthAction.Login) {
    return this.service.login(action.body);
  }

  @Action(AuthAction.LoginConfirm)
  loginConfirm(_: StateContext<AuthType>, action: AuthAction.LoginConfirm) {
    return this.service.loginConfirm(action.body).pipe(
      tap((result) => {
        this.storageService.set(StorageKeys.AccessToken, result);
      })
    );
  }

  @Action(AuthAction.Logout)
  logout(_: StateContext<AuthType>, action: AuthAction.Logout) {
    return this.service.logout().pipe(
      tap(() => {
        this.storageService.remove(StorageKeys.AccessToken);
      })
    );
  }

  @Action(AuthAction.CreateAccount)
  createAccount(ctx: StateContext<AuthType>, action: AuthAction.CreateAccount) {
    return this.service.createAccount(action.body).pipe(tap((_) => {}));
  }

  @Action(AuthAction.ChangePass)
  changePass(ctx: StateContext<AuthType>, action: AuthAction.ChangePass) {
    return this.service.changePass(action.body).pipe(tap((_) => {}));
  }

  @Action(AuthAction.ForgotPswSendCode)
  forgotPswSendCode(
    _: StateContext<AuthType>,
    action: AuthAction.ForgotPswSendCode
  ) {
    return this.service.forgotPswSendCode(action.body);
  }

  @Action(AuthAction.ForgotPswVerifyCode)
  forgotPswVerifyCode(
    _: StateContext<AuthType>,
    action: AuthAction.ForgotPswVerifyCode
  ) {
    return this.service.forgotPswVerifyCode(action.body);
  }

  @Action(AuthAction.ForgotPswReset)
  forgotPswReset(_: StateContext<AuthType>, action: AuthAction.ForgotPswReset) {
    return this.service.forgotPswReset(action.body);
  }
}
